// extracted by mini-css-extract-plugin
export default {"block-animation":"PaymentPending_block-animation__6Ni2y"};